module.exports = __webpack_public_path__ + "img/filter-up.60a8f1da.svg";